import BreadCrumb from "Common/BreadCrumb";
import TableContainer from "Common/TableContainer";
// Icons
import { Search} from "lucide-react";

import React from "react";
import PhoneNumbersData from "./components/tabledata";
import TableSkeleton from "Common/Components/Loader/TableSkeleton";

const FBPhoneNumbers = () => {

  const {
    loading,
    columns,
    PhoneNumbers,
  } = PhoneNumbersData();


  return (
    <React.Fragment>
      <BreadCrumb title="List" pageTitle="PhoneNumbers" />
      <div className="grid grid-cols-1 gap-x-5 xl:grid-cols-12">
        <div className="xl:col-span-12">
          <div className="card" id="PhoneNumberTable">
            <div className="card-body">
              <div className="flex items-center">
                <h6 className="text-15 grow">PhoneNumber List</h6>
              </div>
            </div>
            <div className="!py-3.5 card-body border-y border-dashed border-slate-200 dark:border-zink-500">
              <form action="#!">
                <div className="grid grid-cols-1 gap-5 xl:grid-cols-12">
                  <div className="relative xl:col-span-2">
                    <input
                      type="text"
                      className="ltr:pl-8 rtl:pr-8 search form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                      placeholder="Search for name, email, phone number etc..."
                      autoComplete="off"
                    />
                    <Search className="inline-block size-4 absolute ltr:left-2.5 rtl:right-2.5 top-2.5 text-slate-500 dark:text-zink-200 fill-slate-100 dark:fill-zink-600" />
                  </div>
                </div>
              </form>
            </div>
              {loading ? (
              <TableSkeleton />
            ) : (
            <div className="card-body">
              {PhoneNumbers && PhoneNumbers.length > 0 ? (
                <TableContainer
                  isPagination={true}
                  columns={columns || []}
                  data={PhoneNumbers || []}
                  customPageSize={10}
                      divclassName="-mx-5 -mb-5 overflow-x-auto"
                  tableclassName="w-full border-separate table-custom border-spacing-y-1 whitespace-nowrap"
                  theadclassName="text-left relative rounded-md bg-slate-100 dark:bg-zink-600 after:absolute ltr:after:border-l-2 rtl:after:border-r-2 ltr:after:left-0 rtl:after:right-0 after:top-0 after:bottom-0 after:border-transparent [&.active]:after:border-custom-500 [&.active]:bg-slate-100 dark:[&.active]:bg-zink-600"
                  thclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 font-semibold"
                  tdclassName="px-3.5 py-2.5 first:pl-5 last:pr-5"
                  PaginationClassName="flex flex-col items-center mt-8 md:flex-row"
                />
              ) : (
                <div className="noresult">
                  <div className="py-6 text-center">
                    <Search className="size-6 mx-auto text-sky-500 fill-sky-100 dark:sky-500/20" />
                    <h5 className="mt-2 mb-1">Sorry! No Result Found</h5>
                    <p className="mb-0 text-slate-500 dark:text-zink-200">
                      We've searched more than 199+ PhoneNumbers We did not find
                      any PhoneNumbers for you search.
                    </p>
                  </div>
                </div>
              )}
            </div>
            )}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default FBPhoneNumbers;
